import Vue from "vue";
//import Vuetify from 'vuetify/lib/framework';
//import Vuetify from 'vuetify/lib';
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#061ab1", //GLS Blue
        // secondary: "#f3f3f3", //Light grey
        secondary: "#f3f3f3", //Light grey
        accent: "#ffd100", //GLS Yellow
        error: "#da2029", //GLS Signalrot
        warning: "#ffd100", //GLS Yellow
        info: "#061ab1", //GLS Blue
        success: "#1fa138" //GLS Saftgrün

        // primary: "#172154", //GLS Blau 100%
        // // secondary: "#e7e8ee", //GLS Blau 10%
        // secondary: "#f1f3f8", //GLS Blau 5% - homemade
        // accent: "#fcbf00", //GLS Gelb
        // error: "#da2029", //GLS Signalrot
        // warning: "#fcbf00", //GLS Gelb
        // info: "#172154", //GLS Blau 100%
        // success: "#1fa138" //GLS Saftgrün
      }
    }
  }
});
